export function routes($stateProvider) {
    $stateProvider
        .state('app.crm', {
        url: '/crm',
        abstract: true,
        template: '<div ui-view></div>'
    });
}
routes.$inject = ['$stateProvider'];
